import ndsTokens from 'nicollet-tokens';
import styled from 'styled-components';
import { ndsBoxSizing, ndsFontReset } from '@nicollet/common';

const Microcopy = styled.span`
  ${ndsBoxSizing}
  ${ndsFontReset({
  color: ndsTokens.colors.palette.gray.dark,
  display: 'block',
  fontSize: ndsTokens.font.size.text.small,
  paddingTop: ndsTokens.space.generic.x1
})}
`;

export { Microcopy };
